import { usePetitionDetailsPageData } from 'src/app/pages/petitionDetails/pageContext';

import { usePetitionShareCounts } from '../../../hooks/shareCounts';

/**
 * True while the momentum bar reserves vertical space: share counts are still loading,
 * or the bar would render real content (same eligibility as MomentumBar component).
 * When false, MomentumBar returns null, so we do not mount scroll-past tracking.
 */
export function useMomentumBarSlotVisible(): boolean {
	const {
		data: {
			petition: { commentsConnection },
			mediaSourcesPage,
		},
	} = usePetitionDetailsPageData();
	const { totalShareCount, isLoading: isShareCountsLoading } = usePetitionShareCounts();

	if (isShareCountsLoading) {
		return true;
	}

	const commentsCount = commentsConnection.totalCount || 0;
	const sharesCount = totalShareCount ?? 0;
	const hasMediaMentions = mediaSourcesPage.numberOfMediaSources > 0;

	return commentsCount >= 1 && (sharesCount > 0 || hasMediaMentions);
}
